import { fromDBEntities, fromJsonTemplate } from '@/node-editor/utilities';
import { INode, INodeTemplate, TNodes } from '@/types/node';
import { getWidgetsByRoomService } from '@/widget-editor/utilities';
import { useEffect, useState } from 'react';

interface IProvided<T> {
  widgets: T;
  usingDefault: boolean;
  loadWidgets: () => void;
  setWidgetActive: (id: string, active: boolean) => void;
  replaceWidgets: (newWidgets: INode[] | INodeTemplate[]) => void;
}

export const useWidgets = <T extends TNodes>(
  roomId: string,
  isManager: boolean
): IProvided<T> => {
  const [usingDefault, setUsingDefault] = useState<boolean>(true);
  const [widgets, setWidgets] = useState<T>();

  const setWidgetActive = (id: string, active: boolean) => {
    const { [id]: widget } = widgets;

    setWidgets((prev) => ({
      ...prev,
      [id]: {
        ...widget,
        active,
      },
    }));
  };

  const replaceWidgets = (newWidgets: INode[] | INodeTemplate[]) => {
    if (newWidgets.some((widget) => 'id' in widget)) {
      setUsingDefault(false);
      return setWidgets(fromDBEntities(newWidgets as INode[]) as T);
    }

    setUsingDefault(true);
    const defaultWidgets = fromJsonTemplate(newWidgets as INodeTemplate[]) as T;
    Object.values(defaultWidgets).forEach((w) => {
      w.active = true;
    });
    setWidgets(defaultWidgets);
  };
  // const loadWidgets = async (subscribed: boolean) => {
  const loadWidgets = async () => {
    // if (!subscribed) return;

    setWidgets(undefined);

    const result = await getWidgetsByRoomService(roomId, isManager);

    replaceWidgets(result);
    /*
    if (result.some((widget) => 'id' in widget)) {
      setUsingDefault(false);
      return setWidgets(fromDBEntities(result as INode[]) as T);
    }

    setUsingDefault(true);
    const defaultWidgets = fromJsonTemplate(result as INodeTemplate[]) as T;
    Object.values(defaultWidgets).forEach((w) => {
      w.active = true;
    });
    setWidgets(defaultWidgets);
    */
  };

  // useEffect(() => {
  //   let subscribed = true;

  //   loadWidgets(subscribed);
  //   return () => {
  //     subscribed = false;
  //   };
  // }, [roomId]);

  return {
    widgets,
    usingDefault,
    loadWidgets,
    setWidgetActive,
    replaceWidgets,
  };
};
